@if (content()) {
  <div
    class="nordic-blue-900-bg surface-contrast white-text text-icon-reversed ps-xlarge br-large"
    [class.col-1-12]="isFullWidth()"
  >
    @if (title()) {
      <fcom-heading-tag
        data-testid="heading-tag"
        class="heading-tag"
        [level]="headerLevel()"
        [extraClasses]="headerFontLevel()"
        >{{ title() }}</fcom-heading-tag
      >
    }
    <div class="flex column-wrapper">
      @for (item of articles(); track item.article.contentId) {
        <div data-testid="article-with-icons-article" class="flex flex--column flex-1 flex--basis0">
          <cms-rich-text
            class="flex-1"
            [content$]="item.article | finToObservable"
            [extraClasses]="link() ? '' : 'mr-large-b'"
            [headerLevel]="item.headerLevel"
            [headerStyles]="item.headerStyles"
          />
          @for (relatedLink of item.article.related ?? []; track $index) {
            <div class="flex nowrap">
              <cms-text-link
                [content$]="relatedLink | finToObservable"
                [colorClass]="'white-text text-icon-reversed'"
              />
            </div>
          }
        </div>
      }
    </div>

    @let cta = link();
    @if (cta) {
      <div class="flex flex--end mr-large-t">
        <a
          [finLink]="cta.target?.url"
          [external]="cta.target?.external"
          [attr.target]="cta.target?.openInNewTab ? '_blank' : null"
          class="flex flex--middle white-text text-icon-reversed bold-type no-underline font-body-1 underline-hover font-body-medium-bold"
          data-testid="article-with-icons-cta"
        >
          <span class="title">{{ cta.teaserTitle }}</span>
          <span class="cta">
            <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT" />
          </span>
        </a>
      </div>
    }
  </div>
}
